import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-error-modal',
	templateUrl: './error-modal.html'
})
export class ErrorModalComponent {
	public error;
	public errorDetail;

	constructor(public dialogRef: MatDialogRef<ErrorModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any) {
		this.error = data.error;
		this.errorDetail = data.errorDetail;
	}
}
